/**
 * @generated SignedSource<<013a6521918c6b1b415651022530aaab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeToastComponent_employee$data = {
  readonly image: {
    readonly " $fragmentSpreads": FragmentRefs<"ImagePublicOrPrivate_image">;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "EmployeeToastComponent_employee";
};
export type EmployeeToastComponent_employee$key = {
  readonly " $data"?: EmployeeToastComponent_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeToastComponent_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeToastComponent_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImagePublicOrPrivate_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "588732b2ce397d5f1beedc333ae68a90";

export default node;
